/**
 * @function isNumber - Check that the variable is a number and not NaN
 */
export const isNumber = (value: unknown): boolean => {
  return typeof value === 'number' && !Number.isNaN(value);
};
